import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from './ui/Shared';
import { ArchMotif } from './ui/Ornaments';
export const MentorNetwork = () => {
  const mentors = [{
    role: 'Entrepreneurship Professors',
    desc: 'Academic rigor and venture frameworks.'
  }, {
    role: 'Public Leaders',
    desc: 'Insights into policy and municipal mechanics.'
  }, {
    role: 'Community Organizers',
    desc: 'Ground-level perspective on social impact.'
  }, {
    role: 'Investors',
    desc: 'Feedback on viability and pitch delivery.'
  }, {
    role: 'Student Mentors',
    desc: 'Guidance from recent high-achieving alumni.'
  }];
  return <section className="py-24 md:py-32 bg-ivory relative overflow-hidden" data-id="element-179">
      <div className="absolute inset-0 bg-noise pointer-events-none" data-id="element-180" />

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-181">
        <SectionHeader title="You'll be in the room with people who've built things." subtitle="Learn directly from a curated network of experts who evaluate and build real ventures." data-id="element-182" />

        <div className="flex overflow-x-auto pb-12 -mx-6 px-6 md:mx-0 md:px-0 gap-6 snap-x hide-scrollbar" data-id="element-183">
          {mentors.map((mentor, idx) => <motion.div key={mentor.role} initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: idx * 0.1,
          type: 'spring',
          stiffness: 100
        }} whileHover={{
          y: -10
        }} className="relative min-w-[280px] md:min-w-[320px] bg-parchment/40 border border-bronze/10 p-8 rounded-sm snap-start hover:border-kesari/50 hover:bg-ivory transition-all duration-300 group overflow-hidden shadow-sm hover:shadow-lg" data-id="element-184">
              {/* Decorative Arch Background */}
              <div className="absolute -right-4 -bottom-4 w-32 h-40 text-gold/5 group-hover:text-kesari/10 transition-colors pointer-events-none" data-id="element-185">
                <ArchMotif className="w-full h-full" data-id="element-186" />
              </div>

              <div className="w-12 h-12 mb-6 text-gold/60 group-hover:text-kesari transition-colors relative z-10" data-id="element-187">
                <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="group-hover:scale-110 transition-transform duration-500" data-id="element-188">
                  <rect x="4" y="4" width="40" height="40" stroke="currentColor" strokeWidth="1.5" strokeDasharray="4 4" data-id="element-189" />
                  <circle cx="24" cy="20" r="8" stroke="currentColor" strokeWidth="1.5" data-id="element-190" />
                  <path d="M12 36C12 30 18 28 24 28C30 28 36 30 36 36" stroke="currentColor" strokeWidth="1.5" data-id="element-191" />
                </svg>
              </div>
              <h4 className="font-serif text-xl text-navy mb-2 relative z-10" data-id="element-192">
                {mentor.role}
              </h4>
              <p className="font-sans text-sm text-charcoal/70 relative z-10" data-id="element-193">
                {mentor.desc}
              </p>
            </motion.div>)}
        </div>
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-xs font-sans text-charcoal/40 mt-4 text-center md:text-left" data-id="element-194">
          * Mentors rotate per cohort. Representative categories shown.
        </motion.p>
      </div>
    </section>;
};